import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { FeedPage } from './pages/FeedPage';
import { EventsPage } from './pages/EventsPage';
import { GoFishPage } from './pages/GoFishPage';
import { CatchesPage } from './pages/CatchesPage';
import { FriendsPage } from './pages/FriendsPage';
import { ReviewFlow } from './pages/ReviewFlow';
import { AdminPage } from './pages/AdminPage';
import { BottomNav } from './components/BottomNav';
import { Screen } from './types/navigation';
import { useStore } from './lib/store';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('landing');
  const {
    user
  } = useStore();
  const handleNavigate = (screen: Screen) => {
    setCurrentScreen(screen);
    window.scrollTo(0, 0);
  };
  // Simple secret route for admin
  useEffect(() => {
    if (window.location.search.includes('admin=true')) {
      setCurrentScreen('admin');
    }
  }, []);
  const handleRegisterSuccess = () => {
    // Changed: Go to Feed instead of ReviewFlow immediately
    // User will review later via Catches tab
    setCurrentScreen('feed');
  };
  const renderScreen = () => {
    switch (currentScreen) {
      case 'landing':
        return <LandingPage onRegisterSuccess={handleRegisterSuccess} data-id="element-0" />;
      case 'feed':
        return <FeedPage onNavigate={handleNavigate} data-id="element-1" />;
      case 'events':
        return <EventsPage onNavigate={handleNavigate} data-id="element-2" />;
      case 'go-fish':
        return <GoFishPage onNavigate={handleNavigate} data-id="element-3" />;
      case 'catches':
        return <CatchesPage onNavigate={handleNavigate} data-id="element-4" />;
      case 'friends':
        return <FriendsPage onNavigate={handleNavigate} data-id="element-5" />;
      case 'review-flow':
        return <ReviewFlow onNavigate={handleNavigate} data-id="element-6" />;
      case 'admin':
        return <AdminPage data-id="element-7" />;
      default:
        return <LandingPage onRegisterSuccess={handleRegisterSuccess} data-id="element-8" />;
    }
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-9">
      {renderScreen()}
      {currentScreen !== 'admin' && currentScreen !== 'landing' && <BottomNav currentScreen={currentScreen} onNavigate={handleNavigate} data-id="element-10" />}
    </div>;
}